export default "__VITE_ASSET__BEg4CbSi__"